import {
  Management,
  ManagementConnectionsDetails,
  PostEmailLink,
} from 'app/routes/lazyPages';
import ROUTES from 'app/routes/paths';
import { ACCESSIBLE_ROLES } from 'constants/roles';
import onlySignedInPage from 'hocs/onlySignedInPage';
import { accessOrDefaultRedirect } from 'utils/accessOrDefaultRedirect';

const managementRoutes: RoutesConfig = [
  {
    path: [ROUTES.management.connections.ftp.details._()],
    component: onlySignedInPage(
      accessOrDefaultRedirect(ACCESSIBLE_ROLES.ADMIN)(
        ManagementConnectionsDetails
      )
    ),
    exact: true,
  },
  {
    path: ROUTES.management._(),
    component: onlySignedInPage(
      accessOrDefaultRedirect(ACCESSIBLE_ROLES.MANAGERS)(Management)
    ),
    exact: false,
  },
  {
    path: ROUTES.management.connections.email.postOauth(),
    component: onlySignedInPage(
      accessOrDefaultRedirect(ACCESSIBLE_ROLES.MANAGERS)(PostEmailLink)
    ),
    exact: false,
  },
];

export { managementRoutes };
